import { render, staticRenderFns } from "./AudioSlide.vue?vue&type=template&id=3bc14d5d&scoped=true&"
import script from "./AudioSlide.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AudioSlide.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AudioSlide.vue?vue&type=style&index=0&id=3bc14d5d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc14d5d",
  null
  
)

export default component.exports